//import AscAnserToolContainer from './containers/AscAnserToolContainer.vue'
import AscSignatureSelectionContainer from './containers/AscSignatureSelectionContainer.vue'
import AscFeatureDetailsContainer from './containers/AscFeatureDetailsContainer.vue'

import { role } from '@/utilities/userRoles'

const anserToolRouter = [
  {
    path: '/analytics-developer/signatures',
    name: 'Signatures',
    component: AscSignatureSelectionContainer,
    meta: {
      requiresRole: role.anserUser,
      breadcrumbs: null,
    },
    beforeEnter: (to, from, next) => {
      to.meta.breadcrumbs = [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'ANALYTICS DEVELOPER',
          to: '/analytics-developer',
        },
        {
          text: `SIGNATURES for ${to.query.airline} - ${to.query.platform}`,
        },
      ]
      next()
    },
  },
  {
    path: '/analytics-developer/signatures/feature_details',
    name: 'Feature Details',
    component: AscFeatureDetailsContainer,
    meta: {
      breadcrumbs: null,
    },
    beforeEnter: (to, from, next) => {
      to.meta.breadcrumbs = [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'ANALYTICS DEVELOPER',
          to: '/analytics-developer',
        },
        {
          to: `/analytics-developer/signatures?airline=${
            to.query.airline
          }&platform=${to.query.platform}&lastModifiedDate=${encodeURIComponent(
            to.query.lastModifiedDate,
          )}`,
          text: `SIGNATURES for ${to.query.airline} - ${to.query.platform}`,
        },
        {
          text: `${to.query.featureText} CORRELATED TO THE ${to.query.component}`,
        },
      ]
      next()
    },
  },
]

export default anserToolRouter
